<template>
  <el-tooltip
    :content="label"
    class="item"
    effect="light"
    placement="bottom"
    :enterable="false"
  >
    <el-button
      class="table-action-button"
      :icon="buttonIcon"
      :disabled="disabled"
      :loading="loading"
      @click="clickFunction"
    />
  </el-tooltip>
</template>

<script>
  export default {
    name: 'TableActionButton',
    props: {
      label: { type: String, default: '' },
      // buttonColor: { type: String, default: '' },
      buttonIcon: { type: String, default: '' },
      // Swaps the icon for a spinner and blocks the click while an action runs
      loading: { type: Boolean, default: false },
      clickFunction: { type: Function, default: () => {} },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss">
  .el-button {
    &.table-action-button {
      color: $--color-white;
      color: #ffffff;
      border: 0;
      margin: 0 5px;
      background: none;
      padding: 3px 5px;
      font-size: 1rem;

      &:hover,
      &:focus {
        background-color: $--color-primary;
      }

      i {
        display: flex;
        justify-content: center;
      }

      // Element veils a loading button with rgba(255, 255, 255, 0.35), which on
      // a borderless transparent button reads as a white block. The spinner
      // already carries the state, and is-loading keeps pointer-events: none.
      &.is-loading::before {
        background-color: transparent;
      }

      // @each $color, $value in $table-action-colors {
      //   &--#{$color}:hover {
      //     filter: brightness(0.9);
      //     color: $--color-white;
      //     background-color: $value;
      //   }

      //   &--#{$color}:focus {
      //     color: $--color-white;
      //     background-color: $value;
      //   }
      //   &--#{$color} {
      //     background-color: $value;
      //   }
      // }
    }
  }
</style>
